var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.824,
    height: 23.999,
    viewBox: "0 0 23.824 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1719",
    "data-name": "Group 1719",
    transform: "translate(-241.072 -766.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M255.851,780.143l1.577-.911-2-3.464-1.575.909a6.514,6.514,0,0,0-2.354-1.354V773.5h-4v1.821a6.475,6.475,0,0,0-2.355,1.356l-1.572-.909-2,3.464,1.577.912a6.46,6.46,0,0,0,0,2.713l-1.577.911,2,3.464,1.573-.908a6.562,6.562,0,0,0,2.354,1.354V789.5h4v-1.82a6.454,6.454,0,0,0,2.356-1.355l1.573.907,2-3.464-1.577-.91A6.486,6.486,0,0,0,255.851,780.143Z",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(246.5 778.5)",
    fill: "#efeffa",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M263.39,770.2l1.006-.581-1-1.733-1.006.582a3.465,3.465,0,0,0-1.391-.81V766.5h-2v1.156a3.485,3.485,0,0,0-1.394.8l-1-.579-1,1.733,1,.578a3.456,3.456,0,0,0,.005,1.609l-1.005.58,1,1.733,1.005-.58a3.487,3.487,0,0,0,1.391.811V775.5h2v-1.156a3.491,3.491,0,0,0,1.4-.807l1,.578,1-1.733-1-.577A3.47,3.47,0,0,0,263.39,770.2Z",
    fill: "#E4EAFF",
    stroke: "#000000",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2189",
    "data-name": "Path 2189",
    d: "M1.5,0A1.5,1.5,0,1,1,0,1.5,1.5,1.5,0,0,1,1.5,0Z",
    transform: "translate(258.5 769.5)",
    fill: "#efeffa",
    stroke: "#000000",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.64f7c78583fe0794d06687e53b4e52ac.svg";
export { ForwardRef as ReactComponent };